import "./SHCoding.css";
import "./SHCodingMedia.css";
import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import {Link} from "react-router-dom";
import {RouteNames} from "../constants/RouteNames";

import CountdownsIcon from "../images/Apps/Countdowns-Icon.webp";
import PokeManagerIcon from "../images/Apps/Poke-Manager-Icon.webp";
import YourTurnIcon from "../images/Apps/YourTurn-Icon.webp";
import {useTranslation} from "react-i18next";

function SHCoding() {
    const {t} = useTranslation();

    return (
        <div id="shcoding-div">
            <Header />
            <div id="shcoding-content">
                <h1>SH Coding</h1>
                <div>
                    {t('shCodingDescription')}
                </div>
            </div>
            <div id="shcoding-apps-content">
                <div>
                    <a className="upper-a" href="https://poke-manager.severin-hanke.de" title={`Poké-Manager ${t('website')}`} target="_blank" rel="noopener noreferrer">
                        <img src={PokeManagerIcon} alt={`Poké-Manager ${t('icon')}`}/>
                        <span>Poké-Manager</span>
                    </a>
                    <Link to={RouteNames.shCodingPokeManager} title={t('privacyPolicy')}>
                        <span>{t('privacyPolicy')}</span>
                    </Link>
                </div>
                <div>
                    <a className="upper-a" href="https://play.google.com/store/apps/details?id=de.shcoding.countdown" title="Countdowns Play Store" target="_blank" rel="noopener noreferrer">
                        <img src={CountdownsIcon} alt={`Countdowns ${t('icon')}`}/>
                        <span>Countdowns</span>
                    </a>
                    <Link to={RouteNames.shCodingCountdowns} title={t('privacyPolicy')}>
                        <span>{t('privacyPolicy')}</span>
                    </Link>
                </div>
                <div>
                    <a className="upper-a" href="https://yourturn.severin-hanke.de" title={`YourTurn ${t('website')}`} target="_blank" rel="noopener noreferrer">
                        <img src={YourTurnIcon} alt={`YourTurn ${t('icon')}`}/>
                        <span>YourTurn</span>
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default SHCoding;
